import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  th: {
    translation: {
      PREV: "ย้อนกลับ",
      NEXT: "ถัดไป",
      TITLE: "บริษัท เอส บี พี คอน จำกัด",
      SALE_EMAIL: "อีเมล: sale@sbpcon.co.th",
      SALE_PHONE: "เบอร์โทร: (+66) 98-626-4569",
      mainSection: "หน้าหลัก",
      aboutUs: "เกี่ยวกับเรา",
      aboutUsFooter:
        "บริษัท เอส บี พี คอน จำกัด ก่อตั้งขึ้นในปี 2547 ภายใต้เป้าหมายขององค์กรที่มุ่งเน้นลูกค้าในอุตสาหกรรมโรงรถ และเรามุ่งมั่นที่จะขยายไปสู่อุตสาหกรรมเครือข่าย คลังสินค้าและโลจิสติกส์ อุตสาหกรรมการก่อสร้างและสถาปัตยกรรมในปี 2562",
      serviceUs: "บริการของเรา",
      contactUs: "ติดต่อเรา",
      CLOSE: "ปิด",
      linkFooter: "เชื่อมไปยัง",
      contactUsFooterCompany: "บริษัท เอส บี พี คอน จำกัด (สำนักงานใหญ่)",
      contactUsFooterAddress:
        "เลขที่ 69 ซอยเชื้อเพลิง(อมร) ถนนพระราม 3 แขวงช่องนนทรี เขตยานนาวา กรุงเทพมหานคร 10120",
      contactUsFooterMobilePhone: "เบอร์มือถือ: (+66) 98-626-4569",
      contactUsFooterFixLinePhone: "เบอร์ติดต่อ: (+66) 2-116-8944",
      contactUsFooterEmail: "อีเมล: sale@sbpcon.co.th",
      homeContentSecondHead: "สร้างความฝันให้เป็นจริงไปกับพวกเรา",
      homeContentSecondBody:
        "ทีมงาน SBP CON เป็นการรวมตัวของบุคลากรจากภาคส่วนต่างๆ ของอุตสาหกรรมโครงข่ายสื่อสารโทรคมนาคม การบริหารจัดการคลังสินค้าและโลจิสติกส์ อุตสาหกรรมรับเหมาก่อสร้างทั้งโครงสร้างปูนซีเมนต์และโครงสร้างเหล็ก รวมถึงสถาปัตยกรรม เพื่อให้บริการด้าน ICT ที่ครอบคลุมที่สุดแก่ผู้ประกอบการโทรคมนาคม ผู้ผลิต และผู้ประกอบการ ICT รวมถึงการก่อสร้าง ความพร้อมในการให้บริการแก่บริษัทอสังหาริมทรัพย์ โรงเรียน มหาวิทยาลัย โรงพยาบาล ฯลฯ ทั้งนี้ผู้เชี่ยวชาญในทีมงานของเรามีประสบการ์ณในอุตสาหกรรมโครงข่ายโทรคมนาคมมาตั้งแต่ปี พ.ศ. 2535 และในอุตสาหกรรมรับเหมาก่อสร้างทั้งโครงสร้างปูนซีเมนต์และโครงสร้างเหล็ก 13 ปี ดังนั้นเราจึงมีความมั่นใจว่าเราสามารถให้บริการที่มีคุณภาพและเป็นไปตามความต้องการของลูกค้าในธุรกิจ ICT, ธุรกิจคลังสินค้าและโลจิสติกส์, รวมถึงธุรกิจก่อสร้างและสถาปัตยกรรมในปัจจุบัน",
      aboutUsContentHead: "เราให้บริการจัดการแก้ไขปัญหาสำหรับธุรกิจของคุณ",
      aboutUsContentBody:
        "เรามีวิศวกรที่มีความเชี่ยวชาญและประสบการณ์สูงในด้านโครงข่ายสื่อสารโทรคมนาคม ด้านบริหารจัดการคลังสินค้าและจัดการโลจิสติกส์ทั้งจากฝั่งผู้ประกอบการและผู้ขาย และด้านรับเหมาก่อสร้างโครงสร้างปูนซีเมนต์และโครงสร้างเหล็กรวมถึงด้านสถาปัตยกรรม ระบบปรับอากาศ ระบบไฟฟ้าและสุขาภิบาล ซึ่งมีประสบการณ์ตรงกับเจ้าของธุรกิจอสังหาริมทรัพย์ โรงเรียน โรงพยาบาล ฯลฯ",
      serviceContentHead1: "การให้บริการของเรา",
      serviceContentBody1:
        "เรามีความมั่นใจอย่างเต็มเปี่ยมในการนำเสนอบริการที่หลากหลายและเป็นเลิศแก่ลูกค้าทุกท่านในการบริหารจัดการโครงการด้านต่าง ๆ ดังนี้",
      serviceContentBody2:
        "งานด้านการบริหารจัดการคลังสินค้าและโลจิสติกส์ทั่วประเทศ",
      serviceContentBody3:
        "งานด้านโครงข่ายสื่อสารโทรคมนาคม : งานสำรวจ งานออกแบบ งานติดตั้งอุปกรณ์ งานทดสอบระบบ งานตัดถ่ายระบบ และ งานบำรุงรักษา",
      serviceContentBody4:
        "งานด้านก่อสร้าง : งานสำรวจ งานออกแบบ งานก่อสร้างโครงสร้าง งานสถาปัตยกรรม งานระบบปรับอากาศ งานระบบสุขาภิบาล งานระบบไฟฟ้า และ งานปรับภูมิทัศน์",
      serviceContentHead2: "การบริหารจัดการคลังสินค้าและโลจิสติกส์",
      serviceContentDescribe1: "การจัดการแบบเป็นระเบียบ",
      serviceContentDescribe2: "การขนส่งสินค้า",
      serviceContentDescribe3: "พิธีการศุลกากรและภาษีอากร",
      serviceContentDescribe4: "คลังสินค้าและการบริหารจัดการคลังสินค้า",
      experinceHeadOne: "งานก่อสร้างโครงสร้าง",
      experinceBodyOne: "สร้างโดมโรงเรียนปากคาดพิทยาคม",
      experinceHeadTwo: "งานด้านโครงข่ายสื่อสารโทรคมนาคม",
      experinceBodyTwo1: "5G 2600 MHz",
      experinceBodyTwo2: "1800 MHz & 2100 MHz",
      experinceHeadThree: "งานออกแบบ, งานสถาปัตยกรรม และ งานปรับภูมิทัศน์",
      experinceBodyThree: "โถงต้อนรับ แผนกรังสีวิทยา สถาบันประสาท",
    },
  },
  en: {
    translation: {
      PREV: "PREV",
      NEXT: "NEXT",
      TITLE: "S B P CON Co., Ltd.",
      SALE_EMAIL: "E-mail Us: sale@sbpcon.co.th",
      SALE_PHONE: "Call Us: (+66) 98-626-4569",
      mainSection: "Home",
      aboutUs: "About Us",
      aboutUsFooter:
        "S B P CON Co., Ltd. Were established in 2004. Under goal of customer-oriented organization in garage industry and we motivated to expand to network industry, warehouse & logistics, construction and architecture industry in 2019.",
      serviceUs: "Services",
      contactUs: "Contact Us",
      CLOSE: "Close",
      linkFooter: "Links",
      contactUsFooterCompany: "S B P CON CO.,LTD 69 Soi Chuea Phloeng (Amorn)",
      contactUsFooterAddress:
        "Rama 3 Road, Chong Nonsi Subdistrict, Yannawa District,Bangkok,Thailand 10120",
      contactUsFooterMobilePhone: "Mobile phone: (+66) 98-626-4569",
      contactUsFooterFixLinePhone: "Telephone: (+66) 2-116-8944",
      contactUsFooterEmail: " Email: sale@sbpcon.co.th",
      homeContentSecondHead: "Let's Build Dream With Us",
      homeContentSecondBody:
        "The S B P CON team came together from the various sectors of the network industry, warehouse & logistics, cement & steel structure construction and architecture industry to form a group to provide the most comprehensive ICT service availability to both telecom operators, vendors and ICT operators included construction service availability to real estate companies, schools, universities, hospitals, etc. our experts have been involved in the telecommunication network industry since 1992 and cement & steel structure construction industry about 13 years so we are very capable of delivering the high quality of service and support require by ICT, warehouse & logistics, construction and architecture’s business today.",
      aboutUsContentHead: "We Provide Solution on Your Business",
      aboutUsContentBody:
        "We have highly competent engineers who have very strong background in network and warehouse & logistics management experiences from operators & vendors side. and cement & steel structure construction, architecture, air-condition system, electricity & sanitary system experiences from real estate business's owners, school, hospital, etc.",
      serviceContentHead1: "Current Service provided",
      serviceContentBody1:
        "We have fully confidence in offering excellent service to your organization by providing network, warehouse & logistics, construction and structure project implementation, including survey, design, structure construction, architecture, air-condition system, sanitary system electricity system, network installation, testing & commissioning, integration, cut-over, project management, maintenance and warehouse & logistics management for various of customers.",
      serviceContentBody2:
        "Warehouse and Logistics management across the country",
      serviceContentBody3:
        "Telecommunication Network: Survey, Design, Equipment installation, System testing, System cutting and Maintenance",
      serviceContentBody4:
        "Construction: Survey, Design, Structural construction, Architecture, Air conditioning, Sanitary system, Electrical system and Landscape adjustment",
      serviceContentHead2: "Warehouse & Logistics Management",
      serviceContentDescribe1: "Customs Formality",
      serviceContentDescribe2: "Freight forwarder & Project Cargo",
      serviceContentDescribe3: "Tax & Duty refund",
      serviceContentDescribe4: "Warehouse & Transport",
      experinceHeadOne: "Cement & Steel Structure Construction",
      experinceBodyOne: "Dome at Pak Khat Pittayakhom School",
      experinceHaedTwo: "Telecommunications Network Industry",
      experinceBodyTwo1: "5G 2600 MHz",
      experinceBodyTwo2: "1800 MHz & 2100 MHz",
      experinceHeadThree: "Architecture",
      experinceBodyThree:
        "Reception room at Neurological institute of Thailand",
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "th", // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
